import { render, staticRenderFns } from "./editFullReduction.vue?vue&type=template&id=47a29b1a&scoped=true&"
import script from "./editFullReduction.vue?vue&type=script&lang=js&"
export * from "./editFullReduction.vue?vue&type=script&lang=js&"
import style0 from "./editFullReduction.vue?vue&type=style&index=0&id=47a29b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a29b1a",
  null
  
)

export default component.exports